import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PlayCircle } from "lucide-react";
import { api } from "@/lib/api";
import { NEW_VIDEO_POPUP } from "@/constants/testIds";

export const NewVideoPopup = ({ open, onOpenChange }) => {
  const [video, setVideo] = useState(null);

  useEffect(() => {
    api
      .get("/videos")
      .then((res) => {
        if (res.data.length > 0) setVideo(res.data[0]);
      })
      .catch(() => {});
  }, []);

  if (!video) return null;

  const goToGallery = () => {
    onOpenChange(false);
    setTimeout(() => {
      document.getElementById("videos")?.scrollIntoView({ behavior: "smooth" });
    }, 250);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={NEW_VIDEO_POPUP.dialog} className="max-w-md rounded-[2rem] overflow-hidden p-0">
        <div className="relative aspect-video bg-[#0F2520] flex items-center justify-center">
          {video.thumbnail_storage_path ? (
            <img
              src={`${api.defaults.baseURL}/videos/${video.id}/thumbnail`}
              alt={video.title}
              className="absolute inset-0 w-full h-full object-cover"
            />
          ) : (
            <PlayCircle className="w-14 h-14 text-white/50 relative z-10" />
          )}
          <div className="absolute inset-0 bg-[#0F2520]/30" />
          <PlayCircle className="w-16 h-16 text-white relative z-10" />
        </div>
        <div className="p-6">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-bold text-[#0F2520]">
              New Video from Raijada Kennel!
            </DialogTitle>
            <DialogDescription className="font-light text-[#0F2520]/70">{video.title}</DialogDescription>
          </DialogHeader>
          <Button
            data-testid={NEW_VIDEO_POPUP.watchBtn}
            onClick={goToGallery}
            className="w-full h-12 rounded-full bg-[#D97736] hover:bg-[#0F2520] text-white font-semibold mt-4"
          >
            Watch Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
